import {lazy} from "react";

const SearchDocumentType = lazy(() => import("./SearchDocumentType"));
const SubfolderNew = lazy(() => import("./subfolder-new"));

const documentTypeRoutes = [
    {
        path: "/document-type",
        element: <SearchDocumentType/>,
    },
    {
        path: "/create-subfolder",
        element: <SubfolderNew/>,
    },
];

export default documentTypeRoutes;